var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_138556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9882 0.00219727H-5V23.961H39.9882V0.00219727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9916 9.58915H20.1826V0.00366211H14.7754V9.58915H-4.9812V14.3793H14.7754V23.9608H20.1826V14.3793H39.9916V9.58915Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.99951 2.79224V8.00874H4.81307L-4.99951 2.79224Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.414038 0.0012207L0.270264 0.00782642L12.9937 6.80762V0.0012207H0.414038Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1009 7.97563L-4.99951 0.00244141V1.88171L6.50262 7.97563H10.1009Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8994 15.9854L39.9998 23.9585V22.0793L28.4977 15.9854H24.8994Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.99951 21.2092V15.9927H4.81307L-4.99951 21.2092Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.414038 24L0.270264 23.9933L12.9937 17.1936V24H0.414038Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0236 15.9849L-4.98975 23.9545L-1.47855 23.9581L13.008 16.309V15.9849H10.0236Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 2.79102V8.0075H30.1875L40 2.79102Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5865 0L34.7302 0.00658286L22.0068 6.80635V0H34.5865Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9855 0.0112606L36.6084 0.0109863L22.0198 7.71393V7.98417H25.1063L39.9855 0.0112606Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 21.207V15.9905H30.1875L40 21.207Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5865 23.998L34.7302 23.9914L22.0068 17.1917V23.998H34.5865Z",
    fill: "#00247D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_138556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.36456c75d8b0c689c222dc189b63a772.svg";
export { ForwardRef as ReactComponent };